import { Injectable, inject } from '@angular/core';

import { BooktechAppService, HookType, MiscUtil } from '@btlib-core';

import { BergensportsreiserService } from './bergensportsreiser.service';
import { SportsTravelService } from './sportstravel.service';

export const APP_DATAID = {
  ORDER_OVERVIEW_DATA: "ORDER_OVERVIEW_DATA",
  ORDER_LAST_BID: "ORDER_LAST_BID",

  SETTINGS_ORDER_LIST: "SETTINGS_ORDER_LIST",

  
}


@Injectable({
  providedIn: 'root'
})
export class AppService {
  name = "AppService"
  public bas = inject(BooktechAppService);

  
  bss:BergensportsreiserService|undefined;
  sts:SportsTravelService|undefined;

  data:any = {
    messageTemplates: []
  }


  constructor() {
    if(this.bas.envtest) console.log("AppService: ", this.bas.settings?.appId);

    
    let cid = this.bas.ds.findCid();
    let fc = this.bas.ds.findCompany();
    if (cid == "bergensportsreiser") this.bss = new BergensportsreiserService(this);
    else if (cid == "sportstravel" || fc?.upCmSportstravel) this.sts = new SportsTravelService(this); //TODO:sportstravel

    this.bas.es.ready().then(() => {
      this.onReady();
    })


    this.bas.hs.on(
      HookType.WebApiRequest, 
      (params) => this.onWebApiRequest(params),
      50
    );

   }
   
  onReady() {
    let c = this.bas.ds.config.company;
    if(this.bas.envtest) console.log(MiscUtil.getLogText("AppService.onReady: "), c);

    if (c?.ucObj) {
      this.bas.ui.setTitle(c.label + " - " + "Cloud Booking Backoffice");
      if (c.ucObj.customFavicon) {
        this.bas.style.updateFavicon(c.ucObj.customFavicon);
      }
    }
   
  }

  getPlatform() {

    return MiscUtil.getUrlVars()["cbclassic"] ? "cbclassic" : ("cbadmin" + (this.bas.envdev ? "dev" : ""))
  }


  onWebApiRequest(params:any) {
    if (this.bas.envtest) console.log("AppService.onWebApiRequest: ", params);
    return new Promise<boolean>((res, rej) => {
     

     
      let qp = params.queryParams || { };

      let page = qp["cbapi-page"] ? decodeURIComponent( qp["cbapi-page"] ) : "";
      let action = qp["cbapi-action"];
      let toolsAction = qp["cbapi-tools-action"];
      let error = qp["cbapi-error"];

      let returnUri = qp["cbapi-return-uri"];

      let target = "";
      let queryParams:any = { };

      for (let pn in qp) {
        if (!pn.startsWith("cbapi-option-")) continue;
        let name = pn.substring("cbapi-option-".length);
        queryParams[name] = qp[pn];
      }


      

      let basePath = this.bas.ui.getRouterPrefix();

      if (page) {

        target = basePath + "/" + page;

        
        if (page == "index") {
          target = "/";
        } else if (page == "order/payment") {
          // https://localhost:8201/api/hemsedalaktiv/lib/api?cbapi-page=order%2Fpayment&cbapi-option-showCustomAmount=true&cbapi-option-id=AGM711
          target = basePath + "/common/order/payment";

        }
        else if (page == "confirmUser") {

          target = basePath + "/lib/user/confirm";

          if (error) {
            queryParams = {
              error: error,
            }
          } else {
            let confirmType = qp["cbapi-tools-confirm-type"];
            if (confirmType) {
              queryParams = {
                confirmType: confirmType,
                uid: qp["uid"] || "",
                ck: qp["ck"] || "",
              }
            } else {
              queryParams = {
                action: qp["cbapi-tools-action"],
              }
            }
          }
          if (returnUri) {
            queryParams["return-uri"] = returnUri
          }
        }
      

        
      }

      if (action) {
        if (action == "showNewPasswordDialog") {
          // TODO:test
          target = basePath + "/lib/user/password";


          return;
        }

      }


      if (this.bas.envtest || !target) console.log("page: " + page + ", target: " + target + ", queryParams: ", queryParams);
      
      if (target) {
          this.bas.ui.router.navigate(
            [ target ], 
            { queryParams: queryParams }
          );
          res(false);
      }

      res(false);
      

    });
  }


}
